import React from 'react';
import { Search, Bell, MessageSquare, Menu, ChevronDown } from 'lucide-react';
export const Header = ({
  onToggleSidebar
}) => {
  return <header className="flex items-center justify-between px-4 py-2 bg-white border-b border-gray-200" data-id="element-1255">
      <div className="flex items-center" data-id="element-1256">
        <button onClick={onToggleSidebar} className="p-1 mr-2 rounded-md hover:bg-gray-100" data-id="element-1257">
          <Menu className="w-5 h-5 text-gray-500" data-id="element-1258" />
        </button>
        <div className="flex items-center mr-6" data-id="element-1259">
          <span className="font-bold text-gray-800" data-id="element-1260">WIX STUDIO</span>
          <div className="ml-2 px-2 py-1 bg-gray-200 rounded-md" data-id="element-1261">T</div>
        </div>
        <nav className="hidden md:flex items-center space-x-1" data-id="element-1262">
          <div className="px-3 py-2 flex items-center text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-1263">
            Fun<span className="font-medium" data-id="element-1264">ctions</span>
            <ChevronDown className="ml-1 w-4 h-4" data-id="element-1265" />
          </div>
          <div className="px-3 py-2 flex items-center text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-1266">
            Resources
            <ChevronDown className="ml-1 w-4 h-4" data-id="element-1267" />
          </div>
          <div className="px-3 py-2 flex items-center text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-1268">
            Community
            <ChevronDown className="ml-1 w-4 h-4" data-id="element-1269" />
          </div>
          <div className="px-3 py-2 flex items-center text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-1270">
            Help
            <ChevronDown className="ml-1 w-4 h-4" data-id="element-1271" />
          </div>
        </nav>
      </div>
      <div className="flex items-center" data-id="element-1272">
        <div className="relative mr-4" data-id="element-1273">
          <input type="text" placeholder="Search for tools, apps, help & more..." className="w-64 px-4 py-1 pl-9 text-sm bg-gray-100 border border-gray-200 rounded-full" data-id="element-1274" />
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1275" />
        </div>
        <div className="flex items-center space-x-3" data-id="element-1276">
          <div className="relative" data-id="element-1277">
            <Bell className="w-5 h-5 text-gray-600" data-id="element-1278" />
            <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 text-xs text-white bg-gray-700 rounded-full" data-id="element-1279">
              1
            </span>
          </div>
          <div className="relative" data-id="element-1280">
            <MessageSquare className="w-5 h-5 text-gray-600" data-id="element-1281" />
            <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 text-xs text-white bg-gray-700 rounded-full" data-id="element-1282">
              1
            </span>
          </div>
          <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-sm font-medium text-gray-700" data-id="element-1283">
            G
          </div>
        </div>
      </div>
    </header>;
};